<script setup>
import FormularioVerificacionTelefono from '../../components/formularioVerificacionTelefono.vue';
</script>
<template>
    <FormularioVerificacionTelefono urlSiguiente="/cliente/buscar"/>
</template>